import {svgIconWrapper} from '../svg-icon-wrapper';

import PeopleRegular from './people-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <PeopleRegular {...validProps} />;
}
SvgComponent.iconName = 'usersRegular';

export const PeopleRegularIcon = svgIconWrapper(SvgComponent);
